export enum Alignment {
  LEFT = "left",
  RIGHT = "right",
  CENTER = "center",
  BLOCK = "block"
}
